<div *ngIf="activeColumn$ | async" class="ml-1 text-gray-600">
  <ng-container *ngIf="reversed$ | async">&#9660;</ng-container>
  <ng-container *ngIf="(reversed$ | async) === false">&#9650;</ng-container>
</div>
